export const HIDDEN_PAGE_PREFIX = 'h';
